import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/NewsletterForm/NewsletterForm.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/NewsletterForm/NewsletterForm.ts';

export const prototypeName = 'bePk2rxzV1tbXy2DNjG5sK7vv4P1VlSko8e8kx48In8aLePnQ1i2Zdk6gld4ub7AOdppDqUy1LR3';
export {styles};
export {script};